require.register("log/controllers/indexCtrl", function(exports, require, module){
  $0
  
});

